import { cn } from "@/lib/utils";
import type { CertificateStatus } from "@/lib/types";

const STYLES: Record<CertificateStatus, string> = {
  valid: "border-green/60 bg-green/15 text-green",
  revoked: "border-rose/60 bg-rose/20 text-pink",
  superseded: "border-gold/60 bg-gold/15 text-goldbright",
};

const LABELS: Record<CertificateStatus, string> = {
  valid: "Valid",
  revoked: "Revoked",
  superseded: "Superseded",
};

export function StatusBadge({
  status,
  label,
  className,
}: {
  status: CertificateStatus;
  label?: string;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-2 rounded-full border px-3 py-1 text-[0.68rem] font-semibold uppercase tracking-[0.18em]",
        STYLES[status],
        className,
      )}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {label ?? LABELS[status]}
    </span>
  );
}
